<template>
  <div class="container">
    <van-nav-bar
      title="加盟店管理"
      left-text="返回"
      right-text
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      class="navbar"
    >
      <van-icon name="plus" size=".3rem" slot="right" />
    </van-nav-bar>
    <van-search placeholder="请输入搜索关键词" class="search fixed" @search="onSearch" v-model="keyword" />
    <van-row class="table-header fixed">
      <van-col span="4">
        <van-checkbox @click="onSelectedAll" v-model="checkedAll" />
      </van-col>
      <van-col span="4">帐号</van-col>
      <van-col span="4">省份</van-col>
      <van-col span="4">城市</van-col>
      <van-col span="4">镇区</van-col>
      <van-col span="4">操作</van-col>
    </van-row>
    <div class="content-scroll-list-wrap table-header-navbar footernavbar" ref="scrollWrapper">
      <div class="nodata" v-if="!list.length">没有到任何数据!</div>
      <cube-scroll
        ref="contentScroll"
        :data="list"
        :options="options"
        @pulling-up="onPullingUp"
        @pulling-down="onPullingDown"
      >
        <van-checkbox-group v-model="selected">
          <van-row class="table-list-data" v-for="(item,index) in list">
            <van-col span="4">
              <van-checkbox :key="item.id" :name="item.id" />
            </van-col>
            <van-col span="4">{{item.username}}</van-col>
            <van-col span="4">{{item.province}}</van-col>
            <van-col span="4">{{item.city}}</van-col>
            <van-col span="4">{{item.area}}</van-col>
            <van-col span="4">
              <van-icon name="edit" size="20px" @click="edit(item)" />
            </van-col>
          </van-row>
        </van-checkbox-group>
      </cube-scroll>
    </div>
    <div class="footer-navbar">
      <van-button type="danger" class="op-delete" @click="onDelete">删除</van-button>
    </div>
  </div>
</template>

<script>
import { MerchModel } from "@models/admin/merch";
import { ERR_OK } from "@/common";
const merchModel = new MerchModel();

export default {
  data() {
    return {
      keyword: "",
      list: [],
      options: {
        pullDownRefresh: {
          threshold: 60,
          stopTime: 1000,
          txt: "更新成功"
        },
        pullUpLoad: {
          txt: {
            noMore: "没有了"
          }
        }
      },
      checkedAll: false,
      selected: [],
      totalpage: 1,
      page: 1
    };
  },
  methods: {
    onSelectedAll() {
      this.checkAll = !this.checkAll;
      this.selected = this.$checkedAll(this.list, this.checkAll);
    },
    onClickLeft() {
      this.$redirect("/admin/index");
    },
    onClickRight() {
      this.$delCache("merch_data");
      this.$redirect("/admin/merch/post");
    },
    onPullingUp() {
      if (this.page < this.totalpage) {
        setTimeout(() => {
          this.page++;
          this.get_list();
        }, 1000);
      } else {
        this.$refs.contentScroll.forceUpdate();
      }
    },
    onPullingDown() {
      let params = {};
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        if (this.keyword) {
          params = {
            keyword: this.keyword
          };
        }
        this.get_list(params);
      }, 1000);
    },
    onDelete() {
      if (this.selected.length == 0) {
        this.$toast("至少勾选一个选项");
        return false;
      }
      this.$dialog
        .confirm({
          message: "确定要删除这些加盟店?",
          cancelButtonText: "取消",
          confirmButtonText: "确定"
        })
        .then(() => {
          merchModel
            .delete({
              ids: this.selected
            })
            .then(res => {
              if (res.code == ERR_OK) {
                this.$toast("删除成功!");
                setTimeout(() => {
                  this.list = [];
                  this.get_list();
                }, 1000);
              } else {
                this.$toast(res.msg);
              }
            });
          // this.$redirect("/admin/merch");
        });
    },
    get_list(params = {}) {
      let obj = {
        user_token: localStorage.user_token,
        page: this.page
      };
      Object.assign(obj, params);
      merchModel.get_list(obj).then(res => {
        if (ERR_OK == res.code) {
          this.totalpage = res.data.last_page;
          this.list = this.list.concat(res.data.data);
        }
      });
    },

    edit(data) {
      this.$setCache("merch_data", data);
      this.$redirect("/admin/merch/post", { id: data.id });
    },
    onSearch() {
      this.list = [];
      this.page = 1;
      this.get_list({
        keyword: this.keyword
      });
    },
    onEvent() {
      let name = this.$getCache("data_name");
      let event = this.$getCache("event");
      if (event == "update") {
        let data = this.$getCache(name);
        this.list.forEach((item, index) => {
          if (item.id == data.id) {
            this.list.splice(index, 1, data);
          }
        });
      } else if (event == "add") {
        this.list = [];
        this.get_list();
      }
      this.$setCache("data_name", "");
      this.$setCache("event", "");
    }
  },
  created() {
    this.get_list();
  },
  activated() {
    this.onEvent();
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.navbar {
  color: #fff;
  background: #2196f3;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.content-scroll-list-wrap img {
  max-width: 100%;
}

>>>.table-header {
  top: 2rem;
}

>>>.content-scroll-list-wrap.footernavbar {
  height: calc(100% - 0.92rem - 0.8rem - 0.92rem - 1.1rem);
}

>>> .content-scroll-list-wrap.table-header-navbar {
  top: 2.8rem;
}


</style>
